
import { readAppConfigs, readUserProfile } from "@/store/main/getters";
import {
  dispatchGetActivePackage,
  dispatchGetUserBinaryTree,
  dispatchGetUserRegistrationsTable,
  dispatchGetUserStructureList,
  dispatchSetUserBinaryStructureSide,
  dispatchGetPurchaseStatisticsByPackages, dispAuthFetch,
} from "@/store/mlm/actions";
import {
  readActivePackage,
  readBinaryTree,
  readRecentRegistrations,
} from "@/store/mlm/getters";
import { Component, Vue } from "vue-property-decorator";
import BinaryTreeNodeUser from "@/components/Main/BinaryTreeNodeUser.vue";
import BinaryTreeNodeHint from "@/components/Main/BinaryTreeNodeHint.vue";
import ListPagination from "@/components/Main/ListPagination.vue";
import ListTeamTree from "@/components/Main/Team/ListTeamTree.vue";
import {
  dispatchGetAllConfigs,
  dispatchGetUserProfile,
} from "@/store/main/actions";
import { IPackageStatisticsResponse } from "@/interfaces/mlm";
import EthicsCodexModal from "@/components/Main/EthicsCodexModal.vue";


@Component({
  components: {
    EthicsCodexModal,
    BinaryTreeNodeUser,
    BinaryTreeNodeHint,
    ListPagination,
    ListTeamTree,
  },
})
export default class Team extends Vue {
  // public showPackagePaymentModal: boolean = false;
  // public selectedPackage: IPackage | null = null;
  public selectedUser: number | null = null;
  public activeTab: string = "structure";
  public side: string = "S";
  public referralLink: string = "";
  public structureList: any = [];
  public structureSearchKeyword: string = "";
  public structureSearchResult: any = [];
  public showECodexModal: boolean = false;
  public has_token_user_package: boolean = false
  public virtual_nodes = []
  public packagesStatistics: IPackageStatisticsResponse = {
    binary_bonus: 0,
    purchase_statistics: [],
  };
  public page: number = 1;
  public isLoadPackagesStatistics = false;

  public handleCloseECodexModal(result) {
    this.showECodexModal = false
  }

  public async loadVirtualPackageDepositList() {
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/mlm/virtual_nodes/",
      init: {
        method: "GET",
      },
    });

    if (invoiceResp.status === 200) {
      const invoiceResponse = await invoiceResp.json();
      return invoiceResponse;
    } else {
      this.$toast.error("Failed to create invoice, please try again later", {
        message: "Failed to create invoice, please try again later",
        duration: 3000,
        position: "bottom",
      });
      return null;
    }
  }

  public async mounted() {
    dispatchGetAllConfigs(this.$store);
    this.isLoadPackagesStatistics = true
    await dispatchGetUserProfile(this.$store);
    if (this.userProfile) {
      await this.handleLoadBinaryStructure(this.userProfile.id);
      if (this.binaryTree) {
        this.side = this.binaryTree.side_route;
        this.referralLink = this.binaryTree.referral_link;
      }
      this.handleChangeRegsPage(1, true);
    }
    this.structureList = await dispatchGetUserStructureList(this.$store);
    await dispatchGetActivePackage(this.$store);

    this.packagesStatistics = await dispatchGetPurchaseStatisticsByPackages(
      this.$store,
      {}
    );
    this.isLoadPackagesStatistics = false
    this.virtual_nodes = await this.loadVirtualPackageDepositList()
    await this.handleTokenServiceIntegration()
  }

  public handleSearchInStructure() {
    this.structureSearchResult = [];
    if (this.structureSearchKeyword) {
      for (let i in this.structureList) {
        if (this.structureList[i].label.includes(this.structureSearchKeyword)) {
          this.structureSearchResult.push(this.structureList[i]);
        }
      }
    }
  }

  public async handleChangeRegsPage(page, force = false) {
    if (this.page !== page || force) {
      this.page = page;
      const rowQuery = `?page=${this.page}`;
      // @ts-ignore
      await dispatchGetUserRegistrationsTable(this.$store, {
        data: { user: this.userProfile?.id ?? 0 },
        rowQuery,
      });
    }
  }

  public async handleTokenServiceIntegration() {
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/token_service_integration/token_package/info/",
      init: {
        method: "POST",
        body: {},
      },
    });

    if (invoiceResp.status === 200) {
      this.has_token_user_package = (await invoiceResp.json())?.has_token_user_package;
    }
  }

  public async handleLoadBinaryStructure(userId) {
    this.structureSearchKeyword = "";
    this.structureSearchResult = [];

    if (userId) {
      this.selectedUser = userId;
      // @ts-ignore
      await dispatchGetUserBinaryTree(this.$store, { user: this.selectedUser });
      // await dispatchGetUserBinaryObject(this.$store, {user: this.selectedUser});
    }
  }

  public async handleChangeBinarySide() {
    const result = await dispatchSetUserBinaryStructureSide(this.$store, {
      side: this.side,
    });
    if (result) {
      // @ts-ignore
      this.$toast.success(this.$t("Branch saved"), {
        duration: 2000,
        position: "bottom",
      });
    } else {
      // @ts-ignore
      this.$toast.error(this.$t("Unable to save"), {
        duration: 2000,
        position: "bottom",
      });
    }
  }

  // public handleOpenPackagePaymentModal(pack) {
  //   this.selectedPackage = pack;
  //   this.showPackagePaymentModal = true;
  // }

  // public handleClosePackagePaymentModal() {
  //   this.showPackagePaymentModal = false;
  //   this.selectedPackage = null;
  // }
  get userProfile() {
    return readUserProfile(this.$store);
  }
  get binaryTree() {
    return readBinaryTree(this.$store);
  }
  get recentRegistrations() {
    return readRecentRegistrations(this.$store);
  }
  get activePackage() {
    return readActivePackage(this.$store);
  }
  get appConfigs() {
    return readAppConfigs(this.$store);
  }
}
